// src/pages/RegisterPage.tsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { API_BASE, REGISTER_ENDPOINT } from '../config';
import '../styles/auth.css';
import { setAuthFromLogin } from '../api/Client';
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Capacitor } from "@capacitor/core";


/* Inline icons */
const UserIcon = () => (<svg viewBox="0 0 24 24"><path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4 0-8 2-8 6v2h16v-2c0-4-4-6-8-6Z" /></svg>);
const MailIcon = () => (<svg viewBox="0 0 24 24"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4-8 5L4 8V6l8 5 8-5v2Z" /></svg>);
const PhoneIcon = () => (<svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.2 11.7 11.7 0 0 0 3.7.6 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 8a1 1 0 0 1 1-1h3.4a1 1 0 0 1 1 1 11.7 11.7 0 0 0 .6 3.7 1 1 0 0 1-.2 1Z" /></svg>);
const LockIcon = () => (<svg viewBox="0 0 24 24"><path d="M17 8h-1V6a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-6 0V6a2 2 0 1 1 4 0v2h-4Z" /></svg>);
const GenderIcon = () => (<svg viewBox="0 0 24 24"><path d="M20 4h-6v2h2.6l-3 3a6 6 0 1 0 1.4 1.4l3-3V10h2V4ZM9 12a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z" /></svg>);
const CalendarIcon = () => (<svg viewBox="0 0 24 24"><path d="M7 2h2v2h6V2h2v2h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3V2Zm13 8H4v10h16V10Z" /></svg>);
const PinIcon = () => (<svg viewBox="0 0 24 24"><path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7Zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z" /></svg>);
const IdIcon = () => (<svg viewBox="0 0 24 24"><path d="M3 5h18v14H3V5Zm2 2v10h14V7H5Zm3 2h6v2H8V9Zm0 3h8v2H8v-2Z" /></svg>);
const CameraIcon = () => (<svg viewBox="0 0 24 24"><path d="M9.17 4 8 6H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3l-1.17-2H9.17ZM12 17a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" /></svg>);



export default function RegisterPage() {
  const [nombre, setNombre] = useState('');
  const [nombreError, setNombreError] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [apellidosError, setApellidosError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [telefono, setTelefono] = useState('');
  const [telefonoError, setTelefonoError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [sexo, setSexo] = useState('');
  const [fechaNacimiento, setFechaNacimiento] = useState('');
  const [fechaError, setFechaError] = useState('');
  const [codigoPostal, setCodigoPostal] = useState('');
  const [codigoPostalError, setCodigoPostalError] = useState('');
  const [direccionPostal, setDireccionPostal] = useState('');
  const [dni, setDni] = useState('');
  const [profilePic, setProfilePic] = useState<File | null>(null);
  const [acceptedTC, setAcceptedTC] = useState(false);
  const [tcError, setTcError] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [dniError, setDniError] = useState('');
  const [dniTutorError, setDniTutorError] = useState('');

  


  const [message, setMessage] = useState<string | null>(null);

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [profilePreview, setProfilePreview] = useState<string | null>(null);

  const [tutorNombre, setTutorNombre] = useState('');
  const [tutorApellidos, setTutorApellidos] = useState('');
  const [tutorDni, setTutorDni] = useState('');
  const [isMinor, setIsMinor] = useState(false);

  const [showPassword, setShowPassword] = useState(false);


  const navigate = useNavigate();
  const REGISTER_URL = `${API_BASE}${REGISTER_ENDPOINT}`;

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0] || null;
    if (file) {
      setProfilePic(file);
      setProfilePreview(URL.createObjectURL(file));
    }
  }

  function validateDni(value: string): string {
  const regex = /^(\d{8}[A-Z]|X\d{7}[A-Z])$/;
  if (!regex.test(value.trim())) {
    return "DNI inválido: debe tener 8 números y una letra mayúscula o X + 7 números + letra mayúscula";
  }
  return "";
}


    function handleDniChange(v: string) {
      setDni(v);
    setDniError(validateDni(v));
  }

  function handleDniTutorChange(v: string) {
    setTutorDni(v);
    setDniTutorError(validateDni(v));
  }


  async function pickImage() {
  if (Capacitor.getPlatform() === "web") {
    fileInputRef.current?.click();
  } else {
    const image = await Camera.getPhoto({
      quality: 80,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Prompt,
    });

    if (image.dataUrl) {
      setProfilePreview(image.dataUrl);
      const res = await fetch(image.dataUrl);
      const blob = await res.blob();
      const file = new File([blob], `profile_${Date.now()}.jpg`, { type: "image/jpeg" });
      setProfilePic(file);
    }
  }
}



  function handleNombreChange(v: string) {
    setNombre(v);
    setNombreError(v.trim().length < 3 ? "Debe tener al menos 3 caracteres" : "");
  }
  function handleApellidosChange(v: string) {
    setApellidos(v);
    setApellidosError(v.trim().length < 3 ? "Debe tener al menos 3 caracteres" : "");
  }
  function handleTelefonoChange(v: string) {
  setTelefono(v);
  if (v.length < 9) {
    setTelefonoError("El teléfono debe tener al menos 9 caracteres");
  } else if (v.length > 10) {
    setTelefonoError("Máx 10 caracteres");
  } else {
    setTelefonoError("");
  }
}

  function handleCodigoPostalChange(v: string) {
  setCodigoPostal(v);

  const regex = /^40\d{3}$/;
  if (!regex.test(v.trim())) {
    setCodigoPostalError("El código postal debe pertenecer a la provincia de Segovia");
  } else {
    setCodigoPostalError("");
  }
}

  function handlePasswordChange(v: string) {
    setPassword(v);
    const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    setPasswordError(passRegex.test(v) ? "" : "Debe tener mayúscula, minúscula, número y 6+ caracteres");
  }

  function handleFechaChange(v: string) {
  setFechaNacimiento(v);
  if (v) {
    const [y, m, d] = v.split("-").map(Number);
    const nacimiento = new Date(y, m - 1, d);
    const hoy = new Date();
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) edad--;

    if (edad < 18) {
      setIsMinor(true);
      setFechaError("Al ser menor de edad necesitamos la autorizacion de un tutor mayor de edad");
    } else {
      setIsMinor(false);
      setFechaError("");
    }
  }
}


  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null); setMessage(null);

    if (!acceptedTC) {
      setTcError("Debes aceptar los Términos y Condiciones");
      return;
    }

    const [y, m, d] = fechaNacimiento.split("-");
    const fecha = fechaNacimiento ? `${d}${m}${y}` : "";

    const formData = new FormData();
    formData.append('nombre', nombre.trim());
    formData.append('apellidos', apellidos.trim());
    formData.append('email', email.trim().toLowerCase());
    formData.append('telefono', telefono.trim());
    formData.append('password', password);
    if (sexo) formData.append('sexo', sexo === 'M' ? 'Male' : 'Female');
    formData.append('fecha_nacimiento', fecha);
    formData.append('codigoPostal', codigoPostal.trim());
    if (direccionPostal) formData.append('direccionPostal', direccionPostal.trim());
    if (dni) formData.append('dni', dni.trim());
    if (profilePic) formData.append('profile_pic', profilePic);

    if (isMinor) {
        formData.append('tutor_nombre', tutorNombre.trim());
        formData.append('tutor_apellidos', tutorApellidos.trim());
        formData.append('tutor_dni', tutorDni.trim());
      }


    try {
      const res = await fetch(REGISTER_URL, { method: 'POST', body: formData });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || data.message || `Error ${res.status}`);
      setMessage("Registro completado. Redirigiendo…");
      await setAuthFromLogin(data);
      setTimeout(() => navigate('/login'), 1500);
    } catch (err: any) {
      setError(err.message || "No se pudo completar el registro");
    }
  }

  return (
    <>
      <div className="top-bar" />
      <div className="auth-page">
        <div className="auth-container">
          <h1 className="auth-title">Registro</h1>
          <form onSubmit={handleSubmit} noValidate>
            {/* Foto de perfil */}
            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
              <div
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "2px solid #ddd",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f9f9f9",
                  cursor: "pointer",
                }}
                onClick={pickImage}
              >
                {profilePreview ? (
                  <img src={profilePreview} alt="profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <span style={{ fontSize: 24 }}>+</span>
                )}
              </div>
            </div>

            {/* input file oculto solo para web */}
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <div className="input-wrap"><UserIcon /><input className="auth-input" placeholder="Nombre" value={nombre} onChange={e=>handleNombreChange(e.target.value)} required /></div>
            {nombreError && <p className="auth-error">{nombreError}</p>}
            <div className="input-wrap"><UserIcon /><input className="auth-input" placeholder="Apellidos" value={apellidos} onChange={e=>handleApellidosChange(e.target.value)} required /></div>
            {apellidosError && <p className="auth-error">{apellidosError}</p>}
            <div className="input-wrap"><MailIcon /><input className="auth-input" type="email" placeholder="Correo electrónico" value={email} onChange={e=>setEmail(e.target.value)} required /></div>
            {emailError && <p className="auth-error">{emailError}</p>}
            <div className="input-wrap"><PhoneIcon /><input className="auth-input" type="tel" placeholder="Teléfono" value={telefono} onChange={e=>handleTelefonoChange(e.target.value)} required /></div>
            {telefonoError && <p className="auth-error">{telefonoError}</p>}
            <div className="input-wrap" style={{ display: "flex", alignItems: "center" }}>
              <LockIcon />
              <input
                className="auth-input"
                type={showPassword ? "text" : "password"}
                placeholder="Contraseña"
                value={password}
                onChange={e => handlePasswordChange(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(prev => !prev)}
                style={{
                  marginLeft: 8,
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "#1976d2",
                  fontSize: 12
                }}
              >
                {showPassword ? "Ocultar" : "Ver"}
              </button>
            </div>
            {passwordError && <p className="auth-error">{passwordError}</p>}
            <div className="input-wrap"><GenderIcon />
              <select className="auth-select" value={sexo} onChange={e=>setSexo(e.target.value)}>
                <option value="">Sexo(Prefiero no decirlo)</option><option value="M">Masculino</option><option value="F">Femenino</option>
              </select>
            </div>
            <div className="input-wrap">
              <CalendarIcon />
              <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <label style={{ fontSize: "12px", color: "#555", marginBottom: "4px" }}>
                  Fecha de Nacimiento
                </label>
                <input
                  className="auth-input"
                  type="date"
                  value={fechaNacimiento}
                  onChange={e => handleFechaChange(e.target.value)}
                  required
                />
              </div>
            </div>
            {fechaError && <p className="auth-error">{fechaError}</p>}
            <div className="input-wrap"> <PinIcon />
            <input
              className="auth-input"
              placeholder="Código Postal"
              value={codigoPostal}
              onChange={e => handleCodigoPostalChange(e.target.value)}
              required
            />
          </div>
          {codigoPostalError && <p className="auth-error">{codigoPostalError}</p>}

            <div className="input-wrap"><PinIcon /><input className="auth-input" placeholder="Dirección Postal(Opcional)" value={direccionPostal} onChange={e=>setDireccionPostal(e.target.value)} /></div>
             <div className="input-wrap">
              <IdIcon />
              <input
                className="auth-input"
                placeholder="DNI(Opcional)"
                value={dni}
                onChange={e => handleDniChange(e.target.value)}
              />
            </div>
            {dniError && <p className="auth-error">{dniError}</p>}


            {isMinor && (
              <>
                <div className="input-wrap"><UserIcon /><input className="auth-input" placeholder="Nombre del Tutor" value={tutorNombre} onChange={e=>setTutorNombre(e.target.value)} required /></div>
                <div className="input-wrap"><UserIcon /><input className="auth-input" placeholder="Apellidos del Tutor" value={tutorApellidos} onChange={e=>setTutorApellidos(e.target.value)} required /></div>
                <div className="input-wrap">
                  <IdIcon />
                  <input
                    className="auth-input"
                    placeholder="DNI del Tutor"
                    value={tutorDni}
                    onChange={e => handleDniTutorChange(e.target.value)}
                    required
                  />
                </div>
                {dniTutorError && <p className="auth-error">{dniTutorError}</p>}
              </>
            )}


            {/* T&C */}
            <div style={{ margin: "10px 0" }}>
              <label>
                <input
                  type="checkbox"
                  checked={acceptedTC}
                  onChange={(e) => {
                    setAcceptedTC(e.target.checked);
                    setTcError(
                      e.target.checked ? "" : "Debes aceptar los Términos y Condiciones"
                    );
                  }}
                />{" "}
                Acepto los{" "}
                <span
                  onClick={() =>
                    window.open(
                      "https://www.humanperformcenter.com/cliente/condiciones",
                      "_blank"
                    )
                  }
                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                >
                  Términos y Condiciones
                </span>
              </label>
            </div>
            {tcError && <p className="auth-error">{tcError}</p>}

            {error && (
                          <p className="auth-error">
                            {error}
                            {error.toLowerCase().includes("email") && (
                              <> — <Link to="/recover-password">¿Has olvidado la contraseña?</Link></>
                            )}
                          </p>
                        )}            {message && <p className="auth-message">{message}</p>}
            <button type="submit" className="auth-button" style={{ color: "#fff" }}>Registrarse</button>
          </form>
          <p className="auth-link">¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link></p>
        </div>
      </div>
    </>
  );
}
